import { create } from "zustand";
import { persist } from "zustand/middleware";

export type PanelBehavior = 0 | 1 | 2; // 0 = Never, 1 = Page Dependent, 2 = Always

interface SettingsStore {
  navPanelBehavior: PanelBehavior;
  toolsPanelBehavior: PanelBehavior;
  setNavPanelBehavior: (behavior: PanelBehavior) => void;
  setToolsPanelBehavior: (behavior: PanelBehavior) => void;
}

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      navPanelBehavior: 1,
      toolsPanelBehavior: 1,
      setNavPanelBehavior: (behavior) => set({ navPanelBehavior: behavior }),
      setToolsPanelBehavior: (behavior) =>
        set({ toolsPanelBehavior: behavior }),
    }),
    {
      name: "fuse-bart-portal.settings",
    },
  ),
);
